enum ManagerAccountEndpoints {
  getOne = "/manager/accounts/:id",
  getMany = "/manager/accounts",
  create = "/manager/accounts",
  delete = "/manager/accounts/:id",
  update = "/manager/accounts/:id",
}

export default ManagerAccountEndpoints;
